import { jsx, jsxs } from "react/jsx-runtime";
import { string, bool, func, oneOfType, element } from "prop-types";
import React, { Component, createRef } from "react";
import Label from "@ingka/label";
import cx from "classnames";
const propTypes = {
  /** Unique ID of the radio */
  id: string.isRequired,
  /** Name attribute of the radio */
  name: string,
  /** Value attribute of the radio */
  value: string.isRequired,
  /** Text that is passed to the Label component */
  label: oneOfType([string, element]),
  /** Function that is triggered on state change of the radio */
  onChange: func,
  /** Defines disabled state of the radio */
  disabled: bool,
  /** Default checked value for the component, makes component Uncontrolled */
  defaultChecked: bool,
  /** Checked value for the component, makes component Controlled */
  checked: bool,
  /** Id used on validation object prop for FormField component */
  describedById: string,
  /** Prefix all classes in every element with this string */
  prefix: string,
  /** Can be used to add classes to base HTML element. */
  className: string,
  /** Sets `required` attribute for `<input>` element */
  required: bool,
  /** Enables subtle radio button styling */
  subtle: bool
};
class RadioButton extends Component {
  constructor(props) {
    super(props);
    if (createRef) {
      this.radiobutton = createRef();
    }
  }
  render() {
    const { className, prefix, id, label, name, value, onChange, disabled, describedById, required, subtle, ...other } = this.props;
    const classes = cx(className, `${prefix}radio`, subtle && `${prefix}radio--subtle`);
    return /* @__PURE__ */ jsxs("span", { className: classes, children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          type: "radio",
          value,
          name,
          id,
          ref: (el) => this.radiobutton = el,
          disabled,
          onChange: disabled ? null : onChange,
          "aria-describedby": describedById,
          required,
          ...other
        }
      ),
      /* @__PURE__ */ jsx("span", { className: `${prefix}radio__symbol` }),
      label && /* @__PURE__ */ jsx("span", { className: `${prefix}radio__label`, children: /* @__PURE__ */ jsx(Label, { prefix, htmlFor: id, label }) })
    ] });
  }
}
RadioButton.defaultProps = {
  prefix: "",
  name: "radioname",
  disabled: false,
  subtle: false
};
RadioButton.propTypes = propTypes;
var RadioButton_default = RadioButton;
export {
  RadioButton_default as default
};
